function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './Marquee.styles';
var Marquee = function Marquee(_ref) {
  var _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 20 : _ref$speed,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    children = _ref.children;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    containerWidth = _useState2[0],
    setContainerWidth = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    marqueeWidth = _useState4[0],
    setMarqueeWidth = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMounted = _useState6[0],
    setIsMounted = _useState6[1];
  var containerRef = useRef(null);
  var marqueeRef = useRef(null);
  var calculateWidth = function calculateWidth() {
    if (marqueeRef.current && containerRef.current) {
      setContainerWidth(containerRef.current.getBoundingClientRect().width);
      setMarqueeWidth(marqueeRef.current.getBoundingClientRect().width);
    }
  };
  useEffect(function () {
    if (isMounted) {
      calculateWidth();
      window.addEventListener('resize', calculateWidth);
    }
    return function () {
      window.removeEventListener('resize', calculateWidth);
    };
  }, [isMounted]);
  useEffect(function () {
    setIsMounted(true);
  }, []);
  var duration = marqueeWidth < containerWidth ? containerWidth / speed : marqueeWidth / speed;
  var isScrollable = marqueeWidth > containerWidth;
  var play = isScrollable ? 'running' : 'paused';
  return !isMounted ? null : /*#__PURE__*/React.createElement(Styled.MarqueeContainer, {
    ref: containerRef
  }, isScrollable && /*#__PURE__*/React.createElement(Styled.Overlay, null), /*#__PURE__*/React.createElement(Styled.Marquee, {
    ref: marqueeRef,
    play: play,
    duration: "".concat(duration, "s"),
    delay: "".concat(delay, "s")
  }, children), isScrollable && /*#__PURE__*/React.createElement(Styled.Marquee, {
    play: play,
    duration: "".concat(duration, "s"),
    delay: "".concat(delay, "s"),
    "aria-hidden": "true"
  }, children));
};
Marquee.propTypes = {
  speed: PropTypes.number,
  delay: PropTypes.number,
  children: PropTypes.element.isRequired
};
Marquee.defaultProps = {
  speed: 20,
  delay: 0
};
export default Marquee;